import { Resource as a, API as r } from "@coveo/platform-client";
const e = class e extends a {
  getLicenseRestricted() {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/license/restricted`)
    );
  }
  getAvailableStatementDetails() {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/definition/statementdetails`)
    );
  }
  getAvailableModifierTemplates() {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/definition/modifiertemplates`)
    );
  }
  getPlatformFeatureModifiers() {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/definition/modifiertemplates/platform-feature`)
    );
  }
  enablePlatformFeatureModifier(t) {
    return this.api.put(
      this.buildPath(
        `${e.baseUrl}/definition/modifiertemplates/platform-feature/${t}`
      )
    );
  }
  disablePlatformFeatureModifier(t) {
    return this.api.delete(
      this.buildPath(
        `${e.baseUrl}/definition/modifiertemplates/platform-feature/${t}`
      )
    );
  }
};
e.baseUrl = `/rest/organizations/${r.orgPlaceholder}`;
let i = e;
export {
  i as OrganizationSettingsResource
};
//# sourceMappingURL=OrganizationSettingsResource.js.map
